export interface IContact {
  firstName: string;
  lastName: string;
  email: string;
}

export default class Contact implements IContact {
  constructor(
    public firstName: string = '',
    public lastName: string = '',
    public email: string = ''
  ) {}

  /**
   *
   * @param input
   * @returns
   */
  static deserialize(input: Object): Contact {
    return input as IContact;
  }
}
